import { css } from 'styled-components'
import { rem } from '../utility'
import { FontFamily, FontSize, LineHeight } from './typography.types'

// Display
export const displayXXL = css`
  font-size: ${rem(76)};
  line-height: ${rem(80)};
  font-weight: 600;
`
export const displayXL = css`
  font-size: ${rem(60)};
  line-height: ${rem(72)};
  font-weight: 600;
`
export const displayLarge = css`
  font-size: ${rem(54)};
  line-height: ${rem(60)};
  font-weight: 600;
`
export const displayMedium = css`
  font-size: ${rem(40)};
  line-height: ${rem(48)};
  font-weight: 600;
`

// Headline
export const headlineLarge = css`
  font-size: ${rem(32)};
  line-height: ${rem(40)};
  font-weight: 600;
`
export const headlineMedium = css`
  font-size: ${rem(28)};
  line-height: ${rem(36)};
  font-weight: 600;
`

// Title
export const titleLarge = css`
  font-size: ${rem(20)};
  line-height: ${rem(28)};
  font-weight: 600;
`
export const titleMedium = css`
  font-size: ${rem(FontSize.large)};
  line-height: ${rem(LineHeight.large)};
  font-weight: 600;
`
export const titleSmall = css`
  font-size: ${rem(FontSize.medium)};
  line-height: ${rem(LineHeight.medium)};
  font-weight: 600;
`

// Body
export const bodyLarge = css`
  font-size: ${rem(FontSize.large)};
  line-height: ${rem(LineHeight.large)};
  font-weight: 400;
`
export const bodyMedium = css`
  font-size: ${rem(FontSize.medium)};
  line-height: ${rem(LineHeight.medium)};
  font-weight: 400;
`
export const bodySmall = css`
  font-size: ${rem(FontSize.small)};
  line-height: ${rem(LineHeight.small)};
  font-weight: 400;
`

// Label
export const labelLarge = css`
  font-size: ${rem(FontSize.medium)};
  line-height: ${rem(LineHeight.medium)};
  font-weight: 600;
`
export const labelMedium = css`
  font-size: ${rem(FontSize.small)};
  line-height: ${rem(LineHeight.small)};
  font-weight: 600;
`
export const labelSmall = css`
  font-size: ${rem(10)};
  line-height: ${rem(LineHeight.small)};
  font-weight: 600;
`

// Code snippet
export const codeSnippetMedium = css`
  font-family: ${FontFamily.mono};
  font-size: ${rem(FontSize.medium)};
  line-height: ${rem(LineHeight.large)};
`
export const codeSnippetSmall = css`
  font-family: ${FontFamily.mono};
  font-size: ${rem(FontSize.small)};
  line-height: ${rem(LineHeight.medium)};
`

// Weight
export const textRegular = css`
  font-weight: 400;
`
export const textSemiStrong = css`
  font-weight: 500;
`
export const textStrong = css`
  font-weight: 600;
`
